function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_1147",
  "data-name": "Ellipse 1147",
  fill: "none",
  stroke: "#ac1ede",
  strokeWidth: 5
}, /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 22.5,
  fill: "none"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Polygon_21",
  "data-name": "Polygon 21",
  transform: "translate(25 48) rotate(-90)",
  fill: "#ac1ede"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 32.16109848022461 37.49999618530273 L 11.83889961242676 37.49999618530273 C 10.23149967193604 37.49999618530273 8.783439636230469 36.67394638061523 7.965340137481689 35.29031753540039 C 7.147240161895752 33.90668869018555 7.12129020690918 32.23978805541992 7.89592981338501 30.83136749267578 L 18.05702972412109 12.3566370010376 C 18.85993003845215 10.89680671691895 20.33394050598145 10.02527713775635 22 10.02527713775635 C 23.66605949401855 10.02527713775635 25.14006996154785 10.89680671691895 25.94297027587891 12.3566370010376 L 36.10406875610352 30.83136749267578 C 36.87871170043945 32.23978805541992 36.85276031494141 33.90668869018555 36.03466033935547 35.29031753540039 C 35.21656036376953 36.67394638061523 33.76850128173828 37.49999618530273 32.16109848022461 37.49999618530273 Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 22 12.5252685546875 C 21.55835914611816 12.5252685546875 20.7434196472168 12.65987777709961 20.2475700378418 13.56142807006836 L 10.08647155761719 32.03616714477539 C 9.608070373535156 32.90596771240234 9.90045166015625 33.65114593505859 10.1173095703125 34.01791763305664 C 10.33417892456055 34.38469696044922 10.84621047973633 34.99999618530273 11.83890151977539 34.99999618530273 L 32.16110229492188 34.99999618530273 C 33.15377807617188 34.99999618530273 33.66580963134766 34.38469696044922 33.8826789855957 34.01791763305664 C 34.09954071044922 33.65114593505859 34.39192199707031 32.90596771240234 33.91352844238281 32.03615570068359 L 23.7524299621582 13.56142807006836 C 23.2565803527832 12.65987777709961 22.44164085388184 12.5252685546875 22 12.5252685546875 M 22 7.525272369384766 C 24.40188407897949 7.525272369384766 26.80377006530762 8.734127044677734 28.13351058959961 11.15183639526367 L 38.29460906982422 29.62656784057617 C 40.86045074462891 34.2917366027832 37.48532104492188 39.99999618530273 32.16110229492188 39.99999618530273 L 11.83890151977539 39.99999618530273 C 6.514671325683594 39.99999618530273 3.139541625976563 34.2917366027832 5.705390930175781 29.62656784057617 L 15.86648941040039 11.15183639526367 C 17.19622993469238 8.734127044677734 19.59811592102051 7.525272369384766 22 7.525272369384766 Z",
  stroke: "none",
  fill: "#fff"
}));

var SvgUsageInfo = function SvgUsageInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_37_32",
    "data-name": "Component 37 \\u2013 32",
    width: 65,
    height: 50,
    viewBox: "0 0 65 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUsageInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/usage-info.05116b59.svg";
export { ForwardRef as ReactComponent };